import "./configurePlan.css";

const formatPrice = (value) => parseFloat(value.toFixed(2)).toString();

const taxAmount = (amount) => (18*amount) / 100;

const includeTax = (amount) => amount + taxAmount(amount);

const getLicenseTitle = (count) => count == 1 ? 'license' : 'licenses';

const TaxDetails = ({currency, sub_total}) => (
  <>
    <div className="summary-divider" />
      <div className="summary-row" style={{marginTop: 20, marginBottom: 15}}>
        <div className="summary-label">Sub Total</div>
        <span className="summary-value">
          {currency}{sub_total}
        </span>
      </div>
      <div className="summary-row" style={{marginTop: 15, marginBottom: 20}}>
        <div className="summary-label">Tax (18%)</div>
        <span className="summary-value">
          {currency}{taxAmount(sub_total)}
        </span>
      </div>
  </>
);

const PurchaseSummary = ({
  planName,
  billingCycle,
  pricePerLicense,
  viewerLicensePrice,
  licenseCount,
  viewerCount,
  addonsList,
  addonCounts,
  currency,
  isInr,
  HeaderButton = null,
  FooterButton = null
}) => {
  let month_count =
    billingCycle === "Monthly" ? 1 : billingCycle === "Quarterly" ? 3 : 12;

  const planTotal = pricePerLicense * licenseCount * month_count;
  const viewerTotal = viewerLicensePrice * viewerCount * month_count;
  const addonsTotal = addonsList?.reduce(
    (sum, addon) =>
      sum + addon.price * (addonCounts[addon.id] || 0) * month_count,
    0,
  );
  const sub_total = planTotal + viewerTotal + addonsTotal;
  const total = isInr ? includeTax(sub_total) : sub_total;
  return (
    <div className="summary-card">
      {HeaderButton && (
        <>
          <HeaderButton />
          <div className="summary-divider" />
        </>
      )}

      <h3 className="summary-title">Purchase summary</h3>
      <div className="summary-row">
        <div>
          <div className="summary-label">{planName} plan</div>
          <div className="summary-detail">
            {currency}
            {pricePerLicense} × {licenseCount} {getLicenseTitle(licenseCount)} × {month_count} m
          </div>
        </div>
        <span className="summary-value">
          {currency}
          {formatPrice(planTotal)}
        </span>
      </div>
      <div
        className="summary-row"
        style={viewerCount == 0 ? { display: "none" } : {}}
      >
        <div>
          <div className="summary-label">Viewer licenses</div>
          <div className="summary-detail">
            {currency}
            {viewerLicensePrice} x {viewerCount} {getLicenseTitle(viewerCount)} x {month_count} m
          </div>
        </div>
        <span className="summary-value">
          {currency}
          {formatPrice(viewerTotal)}
        </span>
      </div>
      <div className="summary-row">
        <span className="summary-label">Billing cycle</span>
        <span className="summary-value">{billingCycle}</span>
      </div>

      {/* Add-ons section — visible when any addon is added */}
      {addonsList?.some((addon) => addonCounts[addon.id] > 0) ? (
        <>
          <div className="summary-divider" />
          <div className="summary-addons-label">Add-ons</div>
          {addonsList
            ?.filter((addon) => addonCounts[addon.id] > 0)
            .map((addon) => (
              <div className="summary-row" key={addon.id}>
                <div>
                  <div className="summary-label">{addon.name}</div>
                  <div className="summary-detail">
                    {currency}
                    {addon.price} x {addonCounts[addon.id]} {getLicenseTitle(addonCounts[addon.id])} x{" "}
                    {month_count}m
                  </div>
                </div>
                <span className="summary-value">
                  {currency}
                  {formatPrice(
                    addon.price * addonCounts[addon.id] * month_count,
                  )}
                </span>
              </div>
            ))}
        </>
      ) : null}

      {isInr ? (
        <TaxDetails currency={currency} sub_total={sub_total} />
      ) : null}

      <div className="summary-divider" />
      <div className="summary-row total">
        <span>Total</span>
        <span>
          {currency}
          {formatPrice(total)}
        </span>
      </div>

      {FooterButton && <FooterButton currency={currency} total={formatPrice(total)} />}
    </div>
  );
};

export default PurchaseSummary;
